import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.isLoading && _vm.thirdPartyUserList.length < 1 ? _c("div", {
    staticClass: "no-third-party"
  }, [_c("span", {
    staticClass: "no-attached-span"
  }, [_vm._v("You do not have any customers yet.")]), _vm.isConsultantOrHolding(_vm.loggedUserData) ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary ml-3",
    on: {
      click: function click($event) {
        return _vm.openSendInvitationAsConsultantModal();
      }
    }
  }, [_vm._v(" Invite user(s) ")]) : _vm.isSalesman(_vm.loggedUserData) ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary ml-3",
    on: {
      click: function click($event) {
        return _vm.fetchList(true);
      }
    }
  }, [_vm._v(" Extend ")]) : _vm._e()], 1) : _c("div", {
    staticClass: "thirdparty-container"
  }, [_c(VAutocomplete, {
    key: _vm.boolRenderer,
    staticClass: "v-text-field-no-label thirdparty-container-selector",
    attrs: {
      items: _vm.thirdPartyUserList,
      "item-text": "full_name",
      "return-object": "",
      "hide-selected": "",
      "hide-no-data": "",
      "hide-details": "auto",
      placeholder: _vm.inputPlaceholder,
      disabled: _vm.isLoading || _vm.disabled,
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.selectThirdPartyUserConfirm();
      }
    },
    model: {
      value: _vm.thirdPartyUserSelected,
      callback: function callback($$v) {
        _vm.thirdPartyUserSelected = $$v;
      },
      expression: "thirdPartyUserSelected"
    }
  }), _vm.isSalesman(_vm.loggedUserData) ? [!_vm.isExtendedList ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      loading: _vm.isLoading
    },
    on: {
      click: function click($event) {
        return _vm.fetchList(true);
      }
    }
  }, [_vm._v(" Extend ")]) : _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: !_vm.canRestrictList
    },
    on: {
      click: function click($event) {
        return _vm.fetchList(false);
      }
    }
  }, [_vm._v(" Restrict ")])] : _vm._e()], 2), _c("confirmationDialog", {
    ref: "confirmationDialog"
  }), _c("SendInvitationAsConsultantModal", {
    ref: "SendInvitationAsConsultantModal"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };